import { render } from "./VUploadList.vue?vue&type=template&id=415d83a7"
import script from "./VUploadList.vue?vue&type=script&lang=js"
export * from "./VUploadList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__